/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:20
 * @LastEditTime: 2019-10-22 17:18:55
 * @LastEditors: Please set LastEditors
 */
import axios from "axios";
import qs from "qs";
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器

axios.interceptors.request.use(
  (config) => {
    config.data = qs.stringify(config.data);
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    };
    // localStorage.setItem(
    //   "access_tokens",
    //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZhMjBlMDgyZjc2ODk4ZTFlMThjMzE3ZjBkMjFlOTYyZjgxYmJhYjRkYzU2MDFjZWZlYmJlNTFhMGRiNTA3MTkzZjZhZDhlODZlMjZmOGVhIn0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6IjZhMjBlMDgyZjc2ODk4ZTFlMThjMzE3ZjBkMjFlOTYyZjgxYmJhYjRkYzU2MDFjZWZlYmJlNTFhMGRiNTA3MTkzZjZhZDhlODZlMjZmOGVhIiwiaWF0IjoxNzM4ODA4NTU1LCJuYmYiOjE3Mzg4MDg1NTUsImV4cCI6MTc0MDEwNDU1NSwic3ViIjoiMSIsInNjb3BlcyI6WyIqIl19.RycMEqnSgcbaBipzV45W3mNePV_3Zwgb3PIGwY91fhRnpyYxiv_3y0OtEn5LGjNU8WtFRIhPxcoN-5g6bZx_J90dJI5gQQfABQOITQo89fy3n9UHFx14KgkcaOHEPbKuDHGDBHSQwHfJPCHsgI7taCL_CTZOaGXEz7gJIUc7X-ClSmFpnshTcB1I7Ghxqlw2H4HB1bzDqAGkt6ZIy3cFMlGRbJOuS1GmJFelmEBVGdg0ef6YGdtNqBR3VnZdkvpID13_P0kSh9p9XGKYXLEYzAk8brYFU3YgoxBZQlC3CZunYGj-GTHFWoqNszAb-klrK1YLl2dgDrzZ4VGJHUCDIUlFfCR4-Oq9gnHPHG8FbttnxYEOXeRfbWt5-jhPhdoTJL5HZR47d92HGgiXL_e9QTFOsmVxGJFQGDgxg95-p2SCNTIiBtDqtUVwo42HDCvHanKgNLYYot8pq5lviscZ6mpPVbPaCB8_HFtghrNcHB7z7aWu85dlWmFfcZ88MVdVXcecdLuJ4c_zseQ8TKP-wCDICH_wB6hcTGkoLRCfoXySOIxnhrYQKbXykXicEgwdUVeaPRJF6j4_MzeAXGq2ygtjl8ApkepMugo2Z5EbAVtBHuXDyj8TWY2FqGGhJjf3K21SZJ7Xt3KmRv92ri_neTbNP3nFgR2W5Y__uPska4U"
    // );
    config.headers.Authorization =
      "Bearer" + " " + localStorage.getItem("access_tokens");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == 100) {
      location.href = location.href.split("#/")[0] + "#/login"; //跳回登陆页面
    }
    return response;
  },
  (error) => {
    if (error.data) {
      return Promise.reject(error.data);
    } else {
      return Promise.reject(error.response.data);
    }
  }
);

//定义全局的api
let api;

if (process.env.VUE_APP_type == "development") {
  api = {
    logistics: "http://znwl.com/admin/v2",
    logistics_2: "http://pps.qwe.com/index.php/",
    pda: "http://znwl.com/pda/v2/",
  };
} else if (process.env.VUE_APP_type == "production") {
  api = {
    logistics: "https://logistics.fangcuanbao.vip/admin/v2",
    logistics_2: "https://pps.fangcuanbao.vip/index.php/",
    pda: "https://logistics.fangcuanbao.vip/pda/v2/",
  };
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(module, url, params = {}) {
  let baseUrl = "";
  if (module == "logistics") {
    baseUrl = api.logistics + url;
  } else if (module == "logistics_2") {
    baseUrl = api.logistics_2 + url;
  } else if (module == "pda") {
    baseUrl = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
